// Correct serial number sorter for CC, REC, SGREC, retirements
const serialSorter = (a, b) => {
  const parseSerial = (value) => {
    if (!value) return { year: 0, index: 0 };

    const parts = value.split("-");
    const year = parseInt(parts[1], 10);
    const index = parseInt(parts[2], 10);

    return { year, index };
  };

  const sa = parseSerial(a.serialNumber);
  const sb = parseSerial(b.serialNumber);

  if (sa.year !== sb.year) return sa.year - sb.year;
  return sa.index - sb.index;
};

export const activeCC = [
  {
    title: "S/n",
    dataIndex: "serialNumber",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    //sorter: (a, b) => a.serialNumber.localeCompare(b.serialNumber),
    sorter: serialSorter,
  },
  {
    title: "Date Created",
    dataIndex: "dateCreated",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => new Date(a.dateCreated) - new Date(b.dateCreated),
  },
  {
    title: "Type of CC",
    dataIndex: "category",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.category.localeCompare(b.category),
  },
  {
    title: "Vintage",
    dataIndex: "vintage",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.vintage.localeCompare(b.vintage),
  },
  {
    title: "Project Name",
    dataIndex: "projectName",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.projectName.localeCompare(b.projectName),
  },
  {
    title: "Project Location",
    dataIndex: "projectLocation",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.projectLocation.localeCompare(b.projectLocation),
  },
  {
    title: "Project Serial No.",
    dataIndex: "projectSerialNo",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.projectSerialNo.localeCompare(b.projectSerialNo),
  },
  {
    title: "Project Link",
    dataIndex: "projectLink",
    editable: true,
    // sorter: (a, b) => a.link - b.link,
    render: (record) => (
      <a href={record} target="_blank" rel="noreferrer">
        Link
      </a>
    ),
  },
  {
    title: "Available Quantity (kgCO2e)",
    dataIndex: "availableQuantity",
    editable: true,
    sorter: (a, b) => a.availableQuantity - b.availableQuantity,
  },
  {
    title: "Total Quantity (kgCO2e)",
    dataIndex: "totalQuantity",
    editable: true,
    sorter: (a, b) => a.totalQuantity - b.totalQuantity,
  },
  {
    title: "Cost (S$/kgCO2e)",
    dataIndex: "cost",
    editable: true,
    sorter: (a, b) => a.cost - b.cost,
  },
  {
    title: "Table Operation",
    dataIndex: "operation",
    editable: false,
  },
];

export const activeREC = [
  {
    title: "S/n",
    dataIndex: "serialNumber",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    //sorter: (a, b) => a.serialNumber.localeCompare(b.serialNumber),
    sorter: serialSorter,
  },
  {
    title: "Date Created",
    dataIndex: "dateCreated",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => new Date(a.dateCreated) - new Date(b.dateCreated),
  },
  {
    title: "Type of REC",
    dataIndex: "category",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.category.localeCompare(b.category),
  },
  {
    title: "Vintage",
    dataIndex: "vintage",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.vintage.localeCompare(b.vintage),
  },
  {
    title: "Project Name",
    dataIndex: "projectName",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.projectName.localeCompare(b.projectName),
  },
  {
    title: "Project Location",
    dataIndex: "projectLocation",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.projectLocation.localeCompare(b.projectLocation),
  },
  {
    title: "Project Serial No.",
    dataIndex: "projectSerialNo",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.projectSerialNo.localeCompare(b.projectSerialNo),
  },
  {
    title: "Project Link",
    dataIndex: "projectLink",
    editable: true,
    // sorter: (a, b) => a.link - b.link,
    render: (record) => (
      <a href={record} target="_blank" rel="noreferrer">
        Link
      </a>
    ),
  },
  {
    title: "Available Quantity (kWh)",
    dataIndex: "availableQuantity",
    editable: true,
    sorter: (a, b) => a.availableQuantity - b.availableQuantity,
  },
  {
    title: "Total Quantity (kWh)",
    dataIndex: "totalQuantity",
    editable: true,
    sorter: (a, b) => a.totalQuantity - b.totalQuantity,
  },
  {
    title: "Cost (S$/kWh)",
    dataIndex: "cost",
    editable: true,
    sorter: (a, b) => a.cost - b.cost,
  },
  {
    title: "Table Operation",
    dataIndex: "operation",
    editable: false,
  },
];
export const activeSGREC = [
  {
    title: "S/n",
    dataIndex: "serialNumber",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    //sorter: (a, b) => a.serialNumber.localeCompare(b.serialNumber),
    sorter: serialSorter,
  },
  {
    title: "Date Created",
    dataIndex: "dateCreated",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => new Date(a.dateCreated) - new Date(b.dateCreated),
  },
  {
    title: "Type of SG REC",
    dataIndex: "category",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.category.localeCompare(b.category),
  },
  {
    title: "Vintage",
    dataIndex: "vintage",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.vintage.localeCompare(b.vintage),
  },
  {
    title: "Project Name",
    dataIndex: "projectName",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.projectName.localeCompare(b.projectName),
  },
  {
    title: "Project Location",
    dataIndex: "projectLocation",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.projectLocation.localeCompare(b.projectLocation),
  },
  {
    title: "Project Serial No.",
    dataIndex: "projectSerialNo",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.projectSerialNo.localeCompare(b.projectSerialNo),
  },
  {
    title: "Project Link",
    dataIndex: "projectLink",
    editable: true,
    // sorter: (a, b) => a.link - b.link,
    render: (record) => (
      <a href={record} target="_blank" rel="noreferrer">
        Link
      </a>
    ),
  },
  {
    title: "Available Quantity (kWh)",
    dataIndex: "availableQuantity",
    editable: true,
    sorter: (a, b) => a.availableQuantity - b.availableQuantity,
  },
  {
    title: "Total Quantity (kWh)",
    dataIndex: "totalQuantity",
    editable: true,
    sorter: (a, b) => a.totalQuantity - b.totalQuantity,
  },
  {
    title: "Cost (S$/kWh)",
    dataIndex: "cost",
    editable: true,
    sorter: (a, b) => a.cost - b.cost,
  },
  {
    title: "Table Operation",
    dataIndex: "operation",
    editable: false,
  },
];
export const templateView = [
  {
    title: "Template Name",
    dataIndex: "templateName",
    editable: false,
    sorter: (a, b) => a.templateName.localeCompare(b.templateName),
  },
  {
    title: "Table Operation",
    dataIndex: "operation",
    editable: false,
  },
];

export const certificateView = [
  {
    title: "Certificate Name",
    dataIndex: "certificateName",
    editable: false,
    sorter: (a, b) => a.certificateName.localeCompare(b.certificateName),
  },
  {
    title: "Table Operation",
    dataIndex: "operation",
    editable: false,
  },
];

export const energyTableView = [
  {
    title: "Plan Name",
    dataIndex: "planName",
    editable: true,
    sorter: (a, b) => a.planName.localeCompare(b.planName),
  },
  {
    title: "Percentage",
    dataIndex: "percentage",
    editable: true,
    sorter: (a, b) => a.percentage - b.percentage,
  },
  {
    title: "Grid Emission Factor",
    dataIndex: "gridEmissionFactor",
    editable: true,
    sorter: (a, b) => a.gridEmissionFactor - b.gridEmissionFactor,
  },
  {
    title: "Renewal",
    dataIndex: "isRenewal",
    editable: true,
    sorter: (a, b) => a.isRenewal - b.isRenewal,
    render: (record) => <a>{record == true || record == "true" ? "True" : "False"}</a>,
  },
  {
    title: "Table Operation",
    dataIndex: "operation",
    editable: false,
  },
];
